import React, {Component} from 'react';
import {getPathAndQuery} from "../../../../util/UrlFragmentSearch";

const GoToActionButton = ({ className, href, onMouseDown, ...props }) => {
  const currentPath = getPathAndQuery().pathname;
  if (href && ('#' + currentPath) === href) {
    // already at this location. Don't self link. Doesn't currently support query param part of string,
    // but that would be good to include
    return <span />
  } else {
    return <div className="text-right">
      <a onMouseDown={onMouseDown} className={`btn btn-link ${className || ''}`} {...{href, ...props}} />
    </div>
  }
}

export default GoToActionButton;